import React from 'react'
import Card from '../../../../../molecules/Card'
import Loading from '../../../../../molecules/Loading'
import { useGetThingSchema, useLevelThings } from '../../../../../../api/things'
import { useClientDetails } from '../../ClientDetailsFormContext'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import ThingContentForm from '../../../AssetDetails/ContentTab/Things/ThingContentForm'
import ErrorBoundary from '../../../../../molecules/ErrorBoundary'

export const ContentManagementView = () => {
  const { client } = useClientDetails()
  const { data, isLoading } = useGetThingSchema(201)
  const { data: things, isLoading: thingValuesLoading } = useLevelThings(201, client.clientId)
  const clientData = {
    ...client,
    assetId: client.clientId,
    levelTypeId: 201
  }
  if (isLoading || thingValuesLoading) {
    return (
      <FadeIn>
        <Card>
          <Loading />
        </Card>
      </FadeIn>
    )
  }
  return (
    <ErrorBoundary name='Client Content Tab'>
      <FadeIn>
        <Card>
          <ThingContentForm asset={clientData} schema={data?.schema} values={things} />
        </Card>
      </FadeIn>
    </ErrorBoundary>
  )
}
